<template>
  <div>
    <h2>{{ $t("bussinesscooperator.title") }}</h2>
    <p>{{ $t("bussinesscooperator.content") }}</p>
    <viewFooter></viewFooter>
  </div>
</template>
<script>
import viewFooter from '@/views/view-footer.vue'
export default {
  name: "NewsPage",
  components: {
    viewFooter
   },
  data() {
    return {
    };
  },
};
</script>

<style scoped>
</style>
